//*Conocer más sobre la aplicación *//
//===================================
// Conocer más / Configuración

import useFunctionInfo from "@/Hooks/useDataInformation/useFunctionInfo";
import type { KnowMore } from "@/Models/MNowMore/knowMore";
import { useEffect, useState } from "react";
//===================================

export const useConfigInfo = () => {
  const { data: knowMoreInfo = [], loading: isLoadings } =
    useFunctionInfo<KnowMore[]>("/Conocermas");

  const [knowMore, setKnowMore] = useState<KnowMore[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const knowMoreInformation = Array.isArray(knowMoreInfo)
      ? knowMoreInfo.length
      : 0;
    const knowMoreInformationData = Array.isArray(knowMoreInfo)
      ? knowMoreInfo
      : [];
    // solo ejecutamos el setTimeout si ya se cargaron los datos.
    if (!isLoadings && knowMoreInformation > 0) {
      const timers = setTimeout(() => {
        setKnowMore(knowMoreInformationData);
        setIsLoading(isLoadings);
      }, 2000); //r retardo de 2 segundos

      return () => clearTimeout(timers);
    }
  }, [knowMoreInfo, isLoadings]);

  return {
    knowMore,
    isLoading,
  };
};
